import { render, staticRenderFns } from "./NoticeManage.vue?vue&type=template&id=7b7a890e&scoped=true"
import script from "./NoticeManage.vue?vue&type=script&lang=js"
export * from "./NoticeManage.vue?vue&type=script&lang=js"
import style0 from "./NoticeManage.vue?vue&type=style&index=0&id=7b7a890e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7a890e",
  null
  
)

export default component.exports